import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { StyledTextLink } from './TextLink.styles';
const TextLink = React.forwardRef(({ children, href, icon, iconPosition = 'right', disabled, ...props }, ref) => (_jsxs(StyledTextLink, { ref: ref, href: !disabled ? href : undefined, iconPosition: iconPosition, disabled: disabled, ...props, children: [icon, children] })));
TextLink.displayName = 'TextLink';
export default TextLink;
